(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/products/assets/javascripts/products.js') >= 0) return;  svs.modules.push('/components/tur/products/assets/javascripts/products.js'); "use strict";

(function (svs) {
  svs.tur = svs.tur || {};

  svs.tur.products = svs.tur.products || function () {
    (function init() {
      $('.js-rectangle-product-link').each(function () {
        var _this = this;

        new svs.components.RippleEffect(this.getElementsByClassName('brand-product-rectangle')[0], function (e) {
          e.preventDefault();
          var productName = $(_this).find('[itemprop=name]').attr('id'),
              productUrl = $(_this).attr('href'),
              evt = {
            category: 'Navigation',
            action: 'Game Chooser',
            opt_label: productName
          };
          svs.components.analytics.trackEvent(evt, function () {
            location.href = productUrl;
          });
        });
        $(this).on('click', function (e) {
          e.preventDefault();
          return false;
        });
      });
    })();
  }();
})(svs);
 })(window);